import { OnChanges, ViewChild } from '@angular/core';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DxTreeListComponent } from 'devextreme-angular';
import dxTreeList from 'devextreme/ui/tree_list';
import { LanguageService } from '../../../../../shared/services/language.service';
import { UserService } from '../../../../../shared/services/user.service';
import { DocumentAttributeValue } from '../../../_api/models/document-attribute-value.model';
import { DocumentCodeList } from '../../../_api/models/document-code-list';
import { DocumentAdminService } from '../../../_api/services/document-admin.service';
import { DocumentCardService } from '../../../_api/services/document-card.service';

@Component({
  selector: 'app-document-card-attributes',
  templateUrl: './document-card-attributes.component.html',
  styleUrls: ['./document-card-attributes.component.css']
})
export class DocumentCardAttributesComponent implements OnInit {
  @ViewChild('attributesTreeList', { static: false }) attributesTreeList: DxTreeListComponent;
  dataSourceDocumentAttributes: DocumentAttributeValue[];
  documentAttribute: DocumentAttributeValue;

  @Input() documentId: number;
  @Input() usedAsSearchParameters: boolean;
  @Input() editingMode: any;
  @Input() treeListHeight: any;
  @Input() isReadOnly = false;

  @Output() loading = new EventEmitter<boolean>();
  @Output() attributesList = new EventEmitter<any>();

  constructor(private userService: UserService, public languageService: LanguageService,
    private documentcardService: DocumentCardService, private documentAdminService: DocumentAdminService) { }

  ngOnInit(): void {

  }

  loadAttributes(documentId: number) {
    if (documentId !== undefined && documentId !== 0) {
      this.documentId = documentId;
      this.documentcardService.GetDocumentAttributesWithValuesOnDocumentId(this.documentId)
        .subscribe((result: any) => { // success path
          this.documentAttribute = result[0];
          this.dataSourceDocumentAttributes = result;
        }, error => { // error path;
        });
    }
  }

  onRowUpdated(e: any) {
  }

  onAttributeSaving(e) {
    let changedItems: any[];
    let attributeValues: any[] = [];
    changedItems = e.changes;
    for (let i = 0; i < changedItems.length; i++) {
      if (!this.usedAsSearchParameters) {
        let recToUpdate: DocumentAttributeValue = new DocumentAttributeValue;
        recToUpdate.DocumentId = this.documentId;
        recToUpdate.DocumentAttributeId = changedItems[i].key;
        recToUpdate.Value = changedItems[i].data.Value;
        if (this.documentId === 0) {
          attributeValues.push(recToUpdate);
        } else {
          this.documentcardService.updateDocumentAttributeValue(recToUpdate).toPromise().then(result => {
            this.loadAttributes(this.documentId);
          }).catch(error => { // error path;
          });
        }
      } else {
        attributeValues.push(changedItems[i].key + "-" + changedItems[i].data.Value);
      }
    }
    if (attributeValues.length > 0) {
      this.attributesList.emit(attributeValues);
      attributeValues = [];
    }
  }
}
